export const FIREBASE_CONFIG = {
  apiKey: 'AIzaSyAuObu6L3WvaTmIQMWzZy5ZWGtTxbrYKgA',
  authDomain: 'journey-mentor-9ee41.firebaseapp.com',
  projectId: 'journey-mentor-9ee41',
  storageBucket: 'journey-mentor-9ee41.appspot.com',
  messagingSenderId: '159030441511',
  appId: '1:159030441511:web:a82a41f552b5839875c002',
  measurementId: 'G-226CW4SK4Q',
}
